/**
 * The "go here" marker on the minimap (the story's guide, `world.story.guide`: the next quest's person or place, set by
 * scene ends and by systems/plainsStory.ts): a gold diamond, pinned to the minimap's rim when it is off the edge.
 */
import type { World } from '@nine/shared';

export function drawQuestPing(
  g: CanvasRenderingContext2D,
  world: World,
  at: (x: number, y: number) => readonly [number, number],
): void {
  const goal = world.story.guide;
  if (!goal || world.interiors.inside) return;
  const [x, y] = at(goal.x, goal.y);
  const S = g.canvas.width;
  const cx = Math.max(3, Math.min(S - 4, x));
  const cy = Math.max(3, Math.min(S - 4, y));
  const blink = Math.floor(world.time * 3) % 2 === 0;
  g.fillStyle = blink ? '#ffd45a' : '#e0a83a';
  g.fillRect(cx - 1, cy - 2, 3, 5);
  g.fillRect(cx - 2, cy - 1, 5, 3);
  g.fillStyle = '#3a2410';
  g.fillRect(cx, cy, 1, 1);
}
